module.exports = __webpack_public_path__ + "static/media/logo.449ca9b4.png";